import { Component, OnInit, ViewChild } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { AtbHomeService } from "../../../services/atbHome.service";
import { NgForm } from "@angular/forms";
import { NgxSpinnerService } from "ngx-spinner";
import swal2 from "sweetalert2";
import { Subscription } from "rxjs";
import { defineLocale } from "ngx-bootstrap/chronos";
import { itLocale } from "ngx-bootstrap/locale";
import { environment } from '../../../../environments/environment';
defineLocale("it", itLocale);

declare var jQuery: any;
@Component({
  selector: "app-voucher-covid-manage",
  templateUrl: "./voucher-covid-manage.component.html",
  styleUrls: ["../../../app.component.css"]
})
export class VoucherCovidManageComponent implements OnInit {

  voucherCovidPath;
  requestsPath;

  voucherRequestData;
  @ViewChild("requestMajorForm") requestMajorForm: NgForm;
  @ViewChild("requestMinorForm") requestMinorForm: NgForm;
  requestMajorData = {
    lavoratore: false,
    studente: false,
    nomeAzienda: null,
    codiceFiscalePartitaIvaAzienda: null,
    indirizzoAzienda: null,
    nomeIstitutoScolastico: null,
    indirizzoIstitutoScolastico: null,
    accept: false
  };
  requestMinorData = {
    minore: true,
    nomeCognomeGenitore: null,
    luogoNascitaGenitore: null,
    dataNascitaGenitore: null,
    indirizzoResidenzaGenitore: null,
    codiceFiscaleGenitore: null,
    cellulare: null,
    email: null,
    nomeIstitutoScolastico: null,
    indirizzoIstitutoScolastico: null,
    accept: false
  };
  maxDataNascitaGenitore: Date;
  errorMessage;

  constructor(
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private router: Router,
    private atbService: AtbHomeService
  ) {
  }

  ngOnInit() {
    this.voucherRequestData = JSON.parse(localStorage.getItem("voucherRequestData"));

    this.voucherCovidPath = 'voucher/covid'
    this.requestsPath = 'richieste'

    this.maxDataNascitaGenitore = new Date();
    this.maxDataNascitaGenitore.setFullYear(this.maxDataNascitaGenitore.getFullYear() - 18);
  }

  onChangeSection(sectionType) {
    switch (sectionType) {
      case 'lavoratore':
        if (this.requestMajorData.lavoratore) {
          this.requestMajorData.studente = false;
          this.requestMajorData.nomeIstitutoScolastico = null;
          this.requestMajorData.indirizzoIstitutoScolastico = null;
        } else {
          this.requestMajorData.nomeAzienda = null;
          this.requestMajorData.codiceFiscalePartitaIvaAzienda = null;
          this.requestMajorData.indirizzoAzienda = null;
        }
        break;
      case 'studente':
        if (this.requestMajorData.studente) {
          this.requestMajorData.lavoratore = false;
          this.requestMajorData.nomeAzienda = null;
          this.requestMajorData.codiceFiscalePartitaIvaAzienda = null;
          this.requestMajorData.indirizzoAzienda = null;
        } else {
          this.requestMajorData.nomeIstitutoScolastico = null;
          this.requestMajorData.indirizzoIstitutoScolastico = null;
        }
        break;
    }
  }

  doRequest() {
    let requestFormData: any = {}
    if (!this.voucherRequestData.minore) {
      requestFormData = { ...this.requestMajorData }
      delete requestFormData.lavoratore
      delete requestFormData.studente
      delete requestFormData.accept
    } else {
      requestFormData = { ...this.requestMinorData }
      delete requestFormData.minore
      delete requestFormData.accept
    }
    const requestData = { ...this.voucherRequestData, ...requestFormData }
    const voucher = this.voucherRequestData.numeroVoucher
    delete requestData.numeroVoucher
    delete requestData.minore
    this.spinner.show();
    this.atbService.newObject(requestData, this.voucherCovidPath + '/' + this.requestsPath + '/' + voucher).subscribe(
      (response) => {
        if (response.outcome.success === true) {
          swal2('Il tuo voucher è stato correttamente emesso. Puoi trovarlo nella tua lista voucher e nella tua casella di posta (mail dell\'account)', '', 'success');
          this.closeRequest();
        } else {
          switch (response.outcome.code) {
            case '0001':
              this.errorMessage = 'Dati inseriti non validi. Verificare i dati inseriti prima di ritentare';
              break;
            case '0002':
              this.errorMessage = 'Questa B-Card non esiste';
              break;
            case '0021':
              this.errorMessage = 'Ci dispiace, non hai diritto al voucher. Per maggiori informazioni contattata ATB';
              break;
            case '0025':
              this.errorMessage = 'Questa B-Card risulta già associata ad un account';
              break;
            case '0026':
              this.errorMessage = 'Attenzione! La B-Card non risulta associata a questo codice fiscale';
              break;
            case '0027':
              this.errorMessage = 'Voucher non trovato';
              break;
            case '0024':
              this.errorMessage = 'Attenzione! Questa B-Card ha già effettuato la richiesta del voucher';
              break;
            default:
              this.errorMessage = 'Qualcosa è andato storto';
              break;
          }
          swal2('Attenzione', this.errorMessage, 'warning');
        }
        this.spinner.hide()
      },
      (error) => {
        console.log('Error ', error);
        this.errorMessage = 'Spiacente, si è verificato un errore tecnico.';
        swal2('Attenzione', this.errorMessage, 'warning');
        this.spinner.hide()
      }
    );
  }

  closeRequest() {
    this.router.navigate(['/voucher-covid/list'])
  }

}



// WEBPACK FOOTER //
// ./src/app/views/voucher-covid/voucher-covid-manage/voucher-covid-manage.component.ts